(() => {
  'use strict';
  const config = window.RetailerCommerce;
  const picker = document.querySelector('[data-a1-market-picker]');
  const form = document.querySelector('#a1-market-form');
  const toggle = picker?.querySelector('[data-a1-market-toggle]');
  const menu = picker?.querySelector('[role="menu"]');
  if (!config || !form || !toggle || !menu) return;
  const buttons = [...menu.querySelectorAll('[data-a1-country]')];
  const choices = Object.fromEntries(buttons.map(button => [button.dataset.a1Country, {language:button.dataset.language,currency:button.dataset.currency}]));
  const current = new URL(location.href);
  const countryParameters = [...current.searchParams].filter(([key])=>key.toLowerCase()==='country');
  const requested = countryParameters[0]?.[1].toUpperCase();
  const fallback = {de:'DE',hu:'HU',cs:'CZ','pt-pt':'PT',pl:'PL'}[String(config.locale).toLowerCase()] || 'DE';
  const visitorCountry = (navigator.languages || [navigator.language]).map(language=>{
    const [base,region]=language.toLowerCase().split('-');
    if(base==='de'&&(config.country==='AT'||region==='at'))return 'AT';
    return {de:'DE',hu:'HU',cs:'CZ',pt:'PT',pl:'PL'}[base];
  }).find(country=>choices[country]);
  const target = choices[requested] ? requested : !requested && config.locale==='en' && visitorCountry ? visitorCountry : choices[config.country] ? config.country : fallback;
  const retryKey = `a1-market:${config.handle}`;
  const positionKey = `a1-market-position:${config.handle}`;
  const desktop = matchMedia('(min-width:1200px) and (hover:hover) and (pointer:fine)');
  let openPosition = null;
  const close = () => {menu.hidden=true;toggle.setAttribute('aria-expanded','false');openPosition=null;};
  const choose = (country,manual=false) => {
    const choice = choices[country];
    const root = config.localeRoots?.[choice?.language];
    if (!choice || typeof root !== 'string') return;
    const destination = new URL(location.href);
    destination.pathname = `${root.replace(/\/$/,'')}/products/${config.handle}`;
    [...destination.searchParams.keys()].filter(key=>key.toLowerCase()==='country').forEach(key=>destination.searchParams.delete(key));
    destination.searchParams.set('country',country);
    form.elements.country_code.value=country;
    form.elements.language_code.value=choice.language;
    form.querySelectorAll('input[name="return_to"]').forEach(input=>input.value=destination.pathname+destination.search+destination.hash);
    try {
      if(manual) sessionStorage.setItem(positionKey,JSON.stringify({y:openPosition??scrollY,country}));
      sessionStorage.setItem(retryKey,`${country}:${choice.language}`);
    } catch {}
    close();
    config.marketReady=false;
    form.requestSubmit();
  };
  toggle.addEventListener('click',()=>{
    if (!desktop.matches) return;
    if (!menu.hidden) return close();
    openPosition=scrollY;menu.hidden=false;toggle.setAttribute('aria-expanded','true');
    (buttons.find(button=>button.dataset.a1Country===config.country)||buttons[0])?.focus({preventScroll:true});
  });
  buttons.forEach(button=>button.addEventListener('click',()=>choose(button.dataset.a1Country,true)));
  menu.addEventListener('keydown',event=>{
    const index=buttons.indexOf(document.activeElement);let next;
    if(event.key==='ArrowDown')next=(index+1)%buttons.length;
    if(event.key==='ArrowUp')next=(index-1+buttons.length)%buttons.length;
    if(event.key==='Home')next=0;if(event.key==='End')next=buttons.length-1;
    if(next!==undefined){event.preventDefault();buttons[next]?.focus({preventScroll:true});}
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!menu.hidden){event.preventDefault();close();toggle.focus({preventScroll:true});}});
  document.addEventListener('click',event=>{if(!picker.contains(event.target))close();});
  document.addEventListener('focusin',event=>{if(!picker.contains(event.target))close();});
  desktop.addEventListener('change',()=>{if(!desktop.matches)close();});
  window.addEventListener('pageshow',event=>{if(event.persisted)location.reload();});
  config.marketReady = config.country===target && String(config.locale).toLowerCase()===choices[target]?.language.toLowerCase() && config.currency===choices[target]?.currency && countryParameters.every(([,value])=>value.toUpperCase()===target);
  if(!config.marketReady){
    let attempted=false;
    try{attempted=sessionStorage.getItem(retryKey)===`${target}:${choices[target]?.language}`;}catch{}
    if(!attempted){choose(target);return;}
    const status=document.querySelector('[data-retailer-status]');
    if(status){status.hidden=false;status.textContent=config.messages?.commerce?.market_error||'Bitte laden Sie die Seite erneut.';}
    document.querySelectorAll('[data-retailer-checkout]').forEach(button=>button.disabled=true);
    return;
  }
  try{
    sessionStorage.removeItem(retryKey);
    const position=JSON.parse(sessionStorage.getItem(positionKey)||'null');
    if(position?.country===config.country&&Number.isFinite(position.y)&&position.y>=0){
      sessionStorage.removeItem(positionKey);
      const restore=()=>requestAnimationFrame(()=>window.scrollTo({top:position.y,behavior:'instant'}));
      if(document.readyState==='complete')restore();else window.addEventListener('load',restore,{once:true});
    }
  }catch{}
})();
